import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Block extends Bloc {

	constructor (src, ctx) {

		super("block", src, ctx, true);
		this.f = (src, ins) => {
			if (ins[0]?.removedFromFight || (ins[0]?.id?.type === "enemy" && ins[0]?.dead && ins[0]?.removed))
				return [0];

			let block = ins[1];

			// Double defend block with amulet
        	if (src.master.run.champion.getPassive("strikedefendmultiplier") && src.model && src.model.name === "Defend")
            	block *= src.master.run.champion.getPassive("strikedefendmultiplier");

            let blockgain = ins[0].modifyBlock(block, src);
			ins[0].gainblock(blockgain, src);
			return [blockgain];
		};
		this.types = [Types.entity, Types.int];
	}
}
